import { lazy } from "react";
import Loadable from "components/Loadable";
import { FormatConstants, routeConstants } from "services/keyConstants";
import { getStatusTypes } from "./service";
import { internalCommunicationDownload, internalCommunicationList } from "api/module/internalCommunication";

// Lazy-loaded components
const Create = Loadable(lazy(() => import("../Create")));
const ViewById = Loadable(lazy(() => import("../ViewById")));
const CommonDetail = Loadable(lazy(() => import("components/CommonDetail/CommonDetail")));

const InternalCommunicationRoute = [
  {
    path: routeConstants.INTERNAL_COMMUNICATION,
    children: [
      {
        path: "detail/:id",
        element: (
          <CommonDetail
            navigateRoute={{
              isCondition: false,
              url: (item) => {
                const basePath = `/${routeConstants.INTERNAL_COMMUNICATION}/${item?._id}`;
                return basePath;
              },
            }}
            url={{ GET: internalCommunicationList, DOWNLOAD: internalCommunicationDownload }}
            getStatusTypes={getStatusTypes}
            filterOptions={{
              [FormatConstants.INTERNAL_COMMUNICATION.INTERNAL_CIRCULAR]: [
                {
                  name: "Status",
                  optionsKey: "statusOptions",
                  isHiddenAll: true,
                },
              ],
            }}
            tableConfig={{
              type: "table",
              title: {
                isVisible: false,
              },
              chip: {
                status: (data) => {
                  let color =
                    data?.row?.status === "Pending"
                      ? "warning"
                      : data?.row?.status === "Negative"
                      ? "error"
                      : "success";
                  return {
                    label: data?.row?.status,
                    color,
                  };
                },
              },
              isViewMode: false,
              addRow: false,
              onSubmit: false,
            }}
          />
        ),
      },
      {
        path: "create",
        element: <Create />,
      },
      {
        path: ":id",
        element: <ViewById />,
      },
    ],
  },
];

export default InternalCommunicationRoute;
